module.exports = __webpack_public_path__ + "static/media/paper-pen.65aa43a9.svg";